import React from 'react'
import {
    Users,
    MousePointer2,
    Clock,
    TrendingUp,
    TrendingDown,
    Eye,
    Minus
} from "lucide-react";
import { Card, CardContent } from '../../ui/Card';
import { Badge } from '../../ui/Badge';


const Metrics = ({ metrics }) => {
    const data = metrics ? [
        {
            title: "Toplam Sayfa Görüntülemeleri",
            value: metrics.totalPageViews.value,
            change: metrics.totalPageViews.change,
            icon: Eye,
            trend: metrics.totalPageViews.change > 0 ? "up" : metrics.totalPageViews.change === 0 ? "neutral" : "down"
        },
        {
            title: "Benzersiz Ziyaretçiler",
            value: metrics.uniqueVisitors.value,
            change: metrics.uniqueVisitors.change,
            icon: Users,
            trend: metrics.uniqueVisitors.change > 0 ? "up" : metrics.uniqueVisitors.change === 0 ? "neutral" : "down"
        },
        {
            title: "Ort. Oturum Süresi",
            value: metrics.avgSessionDuration.value,
            change: metrics.avgSessionDuration.change,
            icon: Clock,
            trend: metrics.avgSessionDuration.change > 0 ? "up" : metrics.avgSessionDuration.change === 0 ? "neutral" : "down"
        },
        {
            title: "Çıkma Oranı",
            value: metrics.bounceRate.value,
            change: metrics.bounceRate.change,
            icon: MousePointer2,
            trend: metrics.bounceRate.change > 0 ? "up" : metrics.bounceRate.change === 0 ? "neutral" : "down"
        }
    ] : [];

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
            {metrics && data.map((metric, index) => {
                const Icon = metric.icon;
                return (
                    <Card key={index} className="shadow-shadowElegant hover:shadow-shadowGlow transition-all duration-300">
                        <CardContent className="p-6">
                            <div className='flex items-center justify-between'>
                                <div>
                                    <p className="text-sm font-medium text-mutedForeground">{metric.title}</p>
                                    <p className="text-2xl font-bold">{metric.value}</p>
                                    <div className="flex items-center mt-4">
                                        {metric.trend === "up" ? (
                                            <TrendingUp className="h-4 w-4 text-success mr-2" />
                                        ) : metric.trend === "neutral" ? (<Minus className="h-4 w-4 text-orange-400 mr-2" />) :
                                            (
                                                <TrendingDown className="h-4 w-4 text-destructive mr-2" />
                                            )}
                                        <Badge
                                            variant={metric.trend === "up" ? "default" : metric.trend === "neutral" ? "neutral" : "destructive"}
                                            className={metric.trend === "up" ? "bg-success/10 text-success hover:bg-success/20" : ""}
                                        >
                                            {metric.change}
                                        </Badge>
                                    </div>
                                </div>
                                <div className="bg-gradientPrimary p-3 rounded-lg">
                                    <Icon className="h-6 w-6 text-white" />
                                </div>
                            </div>



                        </CardContent>
                    </Card>
                );
            })}
        </div>
    )
}

export default Metrics
